<template lang="pug">
.falsebutton(
  v-if="falseButton"
  :class="classes"
  @click="$emit('falsebutton')"
)
  span(
    class="button__text"
    :style="textStyle"
  )
    slot {{ text }}
button(
  v-else
  class="button"
  :disabled="disabled"
  :class="classes"
  :style="styles"
  :is="isButton ? 'ext-link' : 'button'"
  :type="isButton ? false : type"
  :to="to"
  @click="click"
)
  span(
    class="button__text"
    :style="textStyle"
  )
    slot {{ text }}
</template>

<script>
import ExtLink from './Link.vue';

export default {
  components: {
    ExtLink,
  },

  props: {
    disabled: {
      type: Boolean,
      default: false,
    },

    falseButton: {
      type: Boolean,
      default: false,
    },

    notPrevent: {
      type: Boolean,
      default: false,
    },

    text: {
      type: String,
      default: '',
    },

    to: {
      type: [String, Object],
      default: '',
    },

    color: {
      type: String,
      default: 'default',
    },

    size: {
      type: String,
      default: 'default',
    },

    type: {
      type: String,
      default: 'button',
    },

    wide: {
      type: Boolean,
      default: false,
    },

    bold: {
      type: Boolean,
      default: true,
    },

    transform: {
      type: Boolean,
      default: true,
    },

    transparent: {
      type: Boolean,
      default: false,
    },

    shadow: {
      type: Boolean,
      default: false,
    },

    rounded: {
      type: Boolean,
      default: false,
    },

    fill: {
      type: Boolean,
      default: true,
    },

    factor: {
      type: Number,
      default: 1,
    },

    block: {
      type: Boolean,
      default: false,
    },

    searchColor: {
      type: Boolean,
      default: false,
    },

    styleParams: {
      type: Object,
      default() {
        return {};
      },
    },
  },

  computed: {
    isButton() {
      return !!this.to;
    },

    classes() {
      return {
        [`size_${this.size}`]: true,
        [`color_${this.color}`]: true,
        wide: this.wide,
        block: this.block,
        bold: this.bold,
        transform: this.transform,
        transparent: this.transparent,
        shadow: this.shadow,
        rounded: this.rounded,
        fill: !this.fill,
      };
    },

    styles() {
      // Противоречит глупым компонентам, но в данном случае это наиболее быстрое решение
      if (this.$store) {
        const { state } = this.$store;
        const storeColor = state && state.regionProfile;

        const color = this.searchColor
          ? storeColor && state.regionProfile.colorSearch
          : this.color === 'lime'
          ? storeColor && state.regionProfile.colorBtnSuccess
          : this.color === 'filter' &&
            storeColor &&
            state.regionProfile.colorMenuSection;

        return color
          ? {
              backgroundColor: `#${color}`,
              borderColor: `#${color}`,
            }
          : {};
      } else {
        return this.color === 'filter' ? this.styleParams : {};
      }
    },

    textStyle() {
      if (this.factor === 1) {
        return undefined;
      }
      return { 'font-size': `${this.factor * 100}%` };
    },
  },

  methods: {
    click($event) {
      if (!this.notPrevent) {
        $event.preventDefault();
      }
      this.$el.blur();
      this.$emit('click', $event);
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '../../stylus/helpers/mediaqueriesStep'

$text
  align-items center
  display flex
  justify-content center

$button
  padding 0 2.5em
  height 3.5em
  line-height 3.3em
  border-radius .2em
  display inline-block
  font-family 'Roboto', sans-serif
  text-align center
  font-weight normal
  vertical-align middle

$uppercase
  text-transform uppercase

$bold
  font-weight 700

.falsebutton
  @extends $button
  background-color #bfbfbf
  opacity .5

  & .text
    line-height 100%

  &.size_small
    font-size 9px
    +tablet()
      font-size 10px

  &.transform
    @extends $uppercase

  &.bold
    @extends $bold

button.button
  .text
    @extends $text

.button
  @extends $button
  transition all .3s ease
  text-decoration none
  cursor pointer
  border-width 2px
  border-style solid

  &__text
    line-height 100%

  &:disabled
    opacity .7

    &:hover
      cursor default

  &:focus
  &:active
    outline 0

  &:active
    box-shadow inset .5em .3em 1em rgba(0, 0, 0, .1)

  &.color_
    &default, &filter
      color #fff
      background-color #6e6bce
      border-color #6e6bce
      &:hover
        background-color #7884cf
        border-color #7884cf
      &:active
      &:focus
        border-color #6e6bce
        background-color #6e6bce
      &.fill
        color #6e6bce
        &:active
        &:focus
          background-color #fff
        &:hover
          background-color #6e6bce
          border-color #6e6bce

    &disabled
      color #999999
      background-color #e9e9e9
      border-color #e9e9e9
      cursor default

    &green
      color #fff
      background-color #23bb67
      border-color #23bb67
      &:hover
        background-color #3eda72
        border-color #3eda72
      &:focus
      &:active
        background-color #23bb67
        border-color #23bb67
      &.fill
        color #23bb67
        &:focus
        &:active
          color #fff

    &lime
      color #fff
      background-color #45d375
      border-color #45d375
      &:hover
        background-color #61da8a
        border-color #61da8a
        opacity .8
      &:focus
      &:active
        background-color #2ec05f
        border-color #2ec05f
      &.fill
        color #45d375

    &red
      color #eaedef
      background-color #e34b4b
      border-color #e34b4b
      &:hover
        background-color #df3131
        border-color #df3131
      &.fill
        color #e34b4b

    &orange
      color #eaedef
      background-color #FF8921
      border-color #FF8921
      &:hover
        background-color #FFA947
        border-color #FFA947
      &.fill
        color #FF8921

    &transparent
      height auto
      background-color rgba(#000, .5)
      border solid 3px #FFF
      color #FFF
      &:hover
        background-color #6e6bce
        border-color #6e6bce

  &.fill
    background-color #fff

    &:hover
      color #fff

  &.transform
    @extends $uppercase

  &.bold
    @extends $bold

  &.rounded
    border-radius 1.725em

  &.size_nano
    font-size 6px

  &.size_micro
    font-size 8px

  &.size_smallest
    height 20px
    font-size 10px
    line-height 1

  &.size_small
    font-size 9px
    +tablet()
      font-size 10px

  &.size_normal
    font-size 12px

  &.size_medium
    font-size 14px

  &.size_big
    font-size 16px

  &.size_huge
    font-size 20px

  &.shadow
    box-shadow .417em .417em 4.17em rgba(0, 0, 0, .2)

  &.wide
    width 100%

  &.block
    display block
</style>



// WEBPACK FOOTER //
// Button.vue?676999b2